const FINDINGS_CONSTANTS = {
  COLON: ':',
  PERCENT: '%',
  BULLET: '•',
} as const;

export default FINDINGS_CONSTANTS;
